module.exports = "/fonts/Cabin-BoldItalic.ttf";